import { Acc } from '../../../../components/edit-object/design/Accordion';
import { SignatureFields } from '../../../../components/SignatureFields';
import type { ArtworkDetailsForm } from '../useArtworkDetailsForm';

interface Props {
  form: ArtworkDetailsForm;
}

export const SignatureSection = ({ form }: Props) => {
  const { signatures, setSignatures } = form;

  const summary = (() => {
    const first = signatures[0];
    if (!first) return '';
    const display = first.display?.trim();
    const parts = [
      ...(first.type ?? []),
      ...(first.location ?? []),
      ...(display ? [display] : []),
    ].filter(Boolean);
    return parts.join(' · ');
  })();

  return (
    <Acc
      id="sec-signature"
      title="Signature"
      summary={summary}
      emptyPlaceholder="Not signed"
      defaultExpanded
    >
      <SignatureFields value={signatures} onChange={setSignatures} variant="design" />
    </Acc>
  );
};
